export default "__VITE_ASSET___74CqHdX__ 100w";